import styled from 'styled-components';

export const Btn = styled.button`
  border: none;
  border-radius: 2em;
  width: 50px;
  height: 50px;
  font-size: 1.4rem;
`